import React, { FunctionComponent } from 'react';
import Section from '../../section/section';
import styles from './column.module.scss';
import classNames from 'classnames/bind';

export interface IColumnProps {
  containItems: IKontentItem[];
  aligmentInColumn: string;
  aligmentInRow: string;
  border: boolean;
  asset: {
    url: string;
    description: string;
  };
  fullSizeAsset: boolean;
  additionalMarginInColumn: string;
  additionalMarginInRow: string;
  assetHeight: number;
  backgroundColor: string;
}

const cx = classNames.bind(styles);

export const Column: FunctionComponent<IColumnProps> = ({
  containItems,
  aligmentInColumn,
  aligmentInRow,
  border,
  asset,
  fullSizeAsset,
  additionalMarginInColumn,
  additionalMarginInRow,
  backgroundColor,
  assetHeight
}) => {
  const columnWrapperClass = cx({
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    alignRowDefault: aligmentInRow === 'default',
    alignLeft: aligmentInRow === 'left',
    alignRowCenter: aligmentInRow === 'center',
    alignRight: aligmentInRow === 'right',
    alignColumnDefault: aligmentInRow === 'default',
    alignTop: aligmentInColumn === 'top',
    alignColumnCenter: aligmentInColumn === 'center',
    alignBottom: aligmentInColumn === 'down',
    border: border,
    fullSizeAsset: fullSizeAsset
  });

  const columnClass = cx({
    marginSmallColumn: additionalMarginInColumn === 'small',
    marginMediumColumn: additionalMarginInColumn === 'medium',
    marginLargeColumn: additionalMarginInColumn === 'large',
    marginExtraLargeColumn: additionalMarginInColumn === 'extra_large',
    marginSmallRow: additionalMarginInRow === 'small',
    marginMediumRow: additionalMarginInRow === 'medium',
    marginLargeRow: additionalMarginInRow === 'large',
    marginExtraLargeRow: additionalMarginInRow === 'extra_large',
    marginFitContainer: additionalMarginInRow === 'fit_container'
  });

  return (
    <div
      className={`${columnWrapperClass} ${
        styles.columnWrapper
      } ${containItems.length > 0 && styles.paddingMobile}`}
    >
      <div className={`${styles.column} ${columnClass}`}>
        {asset && (
          <div className={styles.asset}>
            <img src={asset.url} alt={asset.description} height={assetHeight} />
          </div>
        )}
        <div className={styles.content}>
          {containItems.map((item, i) => (
            <Section linkedItem={item} key={i} />
          ))}
        </div>
      </div>
    </div>
  );
};
